import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonToolbar } from '@ionic/react';
import type { Recipe } from '../../domain/recipe';
import { useMessages } from '../i18n/LanguageProvider';
import { RecipeDetails } from '../recipes/RecipeDetails';

/**
 * DE: Rezept als Vollbild-Fenster über dem Bildschirm „Heute“.
 * EN: Recipe as a full-screen window above the Today screen.
 */
export function RecipeSheet({
  recipe,
  servings,
  isOpen,
  onClose,
}: {
  recipe: Recipe;
  servings: number;
  isOpen: boolean;
  onClose: () => void;
}) {
  const { t } = useMessages();
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>{t.close}</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <RecipeDetails recipe={recipe} servings={servings} />
      </IonContent>
    </IonModal>
  );
}
